
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/custom-services",
      function () {
        return require("private-next-pages/custom-services/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/custom-services"])
      });
    }
  